import React from 'react'
import { InputProps as AntInputProps } from 'antd'
import {
  InputContainer,
  Label,
  StyledInput,
  StyledPasswordInput,
} from './styled'

export type InputSize = 'small' | 'middle' | 'large'

export interface CustomInputProps extends Omit<AntInputProps, 'size'> {
  size?: InputSize
  label?: string
  showLabel?: boolean
  visibilityToggle?: boolean
  iconRender?: (visible: boolean) => React.ReactNode
}

export const Input: React.FC<CustomInputProps> = ({
  size = 'middle',
  label,
  showLabel = true,
  type,
  visibilityToggle,
  iconRender,
  ...props
}) => {
  const renderInput = () => {
    const commonProps = {
      size: size,
      ...props,
    }

    if (type === 'password') {
      return (
        <StyledPasswordInput
          visibilityToggle={visibilityToggle}
          iconRender={iconRender}
          {...commonProps}
        />
      )
    }

    return <StyledInput {...commonProps} />
  }

  return (
    <InputContainer>
      {showLabel && label && (
        <Label>
          {label}
          {props.required && (
            <span style={{ color: '#ff4d4f', marginLeft: 4 }}>*</span>
          )}
        </Label>
      )}
      {renderInput()}
    </InputContainer>
  )
}

export const SmallInput: React.FC<Omit<CustomInputProps, 'size'>> = (props) => (
  <Input size="small" {...props} />
)

export const MediumInput: React.FC<Omit<CustomInputProps, 'size'>> = (
  props
) => <Input size="middle" {...props} />

export const LargeInput: React.FC<Omit<CustomInputProps, 'size'>> = (props) => (
  <Input size="large" {...props} />
)

export const BaseInput: React.FC<CustomInputProps> = (props) => (
  <Input showLabel={false} {...props} />
)
